require('angular-material-icons');
require('./dist/md-data-table-templates.js');
require('./dist/md-data-table.js');

module.exports = 'mdDataTable';



//////////////////
// WEBPACK FOOTER
// ./~/md-data-table/index.js
// module id = 141
// module chunks = 0